<app-status-pill
    [statusName]="statusName()"
    [statusColor]="statusColor()"
    [statusTooltip]="statusTooltip()"
    [size]="size()"
    [statusPillInfo]="actionRequiredInfoTooltip()">
</app-status-pill>
